module.exports = __webpack_public_path__ + "static/screenshot3-7c938b9fe6db5d7f206f5e8f22af49ce.png";